import { render, staticRenderFns } from "./Clip.vue?vue&type=template&id=641cf8f2&"
import script from "./Clip.vue?vue&type=script&lang=ts&"
export * from "./Clip.vue?vue&type=script&lang=ts&"
import style0 from "./Clip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports